import { useContext, useEffect } from 'react';
import './Informations.css';
import { ButtonNext } from '../../contexts/ButtonNext';
import ReviewFormattedMessage from '../../generics/ReviewFormattedMessage';

export default function Informations ({ slide }) {
  const { setButtonNext } = useContext(ButtonNext);

  useEffect(() => {
    setButtonNext(null)  
  }, [setButtonNext])
  return (
      <div className="Informations">
        <div className="Informations-box box-informations">
          <h2 className="Informations-title">
            <ReviewFormattedMessage descriptor={slide.titre1} />
          </h2>
          <p>
            <ReviewFormattedMessage descriptor={slide.contenu} />
          </p>
        </div>
        <div className="Informations-box box-instructions">
          <h2 className="Informations-title">
            <ReviewFormattedMessage descriptor={slide.titre2} />
          </h2>
          {
            Array.isArray(slide.consignes) && slide.consignes.map((cons, index) => {
              return <p key={index}> <ReviewFormattedMessage descriptor={cons.consigne} /> </p> 
            })
          }
        </div>
      </div>
  );
}